import { Badge } from 'reactstrap';
import cls from 'classnames';
import { faBan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NumericInput } from '../common/forms/NumericInput';
import './BillingRateCountyGroup.scss';

const defaultOnChange = () => { };

export const BillingRateCountyGroup = (props) => {
    const {
        groupType, description, usStateName, current,
        rate = 0, otRate = 0, altRate = 0, sdRate = 0,
        doubleTimeEnabled = false, showDoubleTime = false, shiftDifferentialEnabled = false, showShiftDifferential = false,
        entityName = '', entityType = '', onChange = defaultOnChange, index, showOverTime = false, overTimeEnabled = false,
        isUsCountyGroup, jobTypeName,
    } = props;

    return (
        <tr>
            {isUsCountyGroup ? (
                <>
                    <td className="badge-column">
                        <Badge
                            color="info"
                            className="ml-2"
                        >
                            {groupType === 'Zone' && 'Z'}
                            {groupType === 'Local' && 'L'}
                        </Badge>
                    </td>

                    <td>
                        <span>{description} ({usStateName})</span>
                    </td>
                </>
            ) : (
                <td>
                    <span>{jobTypeName}</span>
                </td>
            )}

            <td className="not-applicable">
                <div>
                    <label>
                        <input
                            name={`${entityName}${entityType}.${index}.billingRate.current`}
                            checked={current}
                            value={current}
                            type="checkbox"
                            onChange={onChange}
                            hidden
                        />

                        <FontAwesomeIcon
                            icon={faBan}
                            className={cls(
                                'cursor-pointer icon-check',
                                {
                                    checked: !current,
                                },
                            )}
                        />
                    </label>
                </div>
            </td>

            <td className="numeric-input">
                <NumericInput
                    className="form-control-sm"
                    name={`${entityName}${entityType}.${index}.billingRate.rate`}
                    disabled={!current}
                    onChange={onChange}
                    value={rate || ''}
                    min={0}
                    placeholder="Rate"
                    required={current}
                    step={0.01}
                />
            </td>

            {Boolean(showShiftDifferential) && (
                <td className="numeric-input">
                    <NumericInput
                        className="form-control-sm"
                        name={`${entityName}${entityType}.${index}.billingRate.sdRate`}
                        disabled={!current || !shiftDifferentialEnabled}
                        onChange={onChange}
                        value={sdRate || ''}
                        min={0}
                        placeholder="Rate"
                        required={current}
                        step={0.01}
                    />
                </td>
            )}

            {Boolean(showOverTime) && (
                <td className="numeric-input">
                    <NumericInput
                        className="form-control-sm"
                        name={`${entityName}${entityType}.${index}.billingRate.otRate`}
                        disabled={!current || !overTimeEnabled}
                        onChange={onChange}
                        value={otRate || ''}
                        min={0}
                        placeholder="Rate"
                        required={current}
                        step={0.01}
                    />
                </td>
            )}

            {Boolean(showDoubleTime) && (
                <td className="numeric-input">
                    <NumericInput
                        className="form-control-sm"
                        name={`${entityName}${entityType}.${index}.billingRate.altRate`}
                        disabled={!current || !doubleTimeEnabled}
                        onChange={onChange}
                        value={altRate || ''}
                        min={0}
                        placeholder="Rate"
                        required={current}
                        step={0.01}
                    />
                </td>
            )}
        </tr>
    );
};